import type { Route } from '~/core/router'

import * as bundles from '~/routes/tv/bundles'
import * as category from '~/routes/tv/category'

export const route: Route = {
  children: [
    {
      path: '/bundles/:bundleId',
      component: [bundles.Title, bundles.TVBundlesPage],
      init: bundles.model.initTvBundlePage,
      left: bundles.model.left,
      meta: {
        title: 'Extras',
      },
    },
    {
      path: '/categories/:categoryId',
      component: [category.Title, category.TVCategoryPage],
      init: category.model.initTvCategoryPage,
      left: category.model.left,
    },
  ],
}
